import DefaultMainPage from "../../pages/DefaultMainPage";
import StoreManagerMain from "./StoreManagerMain";
import StoreTable from "./StoreTable";
import PersonalPackage from "./personalPackage/PersonalPackage";
import PersonalPackageManager from "./personalPackage/PersonalPackageManager";
import StoreTableFav from "./StoreTableFav";

const shopPackageMenuItems = [
    {path: "/shopPackage", component: <StoreManagerMain/>, label: '상점 관리'},
    {path: "/shopPackage/table/fav", component: <StoreTableFav/>, label: '상점 테이블(즐겨찾기)'},
    {path: "/shopPackage/table", component: <StoreTable/>, label: '상점 테이블'},
    {path: "/shopPackage/personalTable", component: <PersonalPackageManager/>, label: '개인화 관리'},
    {path: "/shopPackage/personal", component: <PersonalPackage/>, label: '개인화 테이블'},
];

export const shopPackageRoutes = {
    path: "/shopPackage",
    component: <DefaultMainPage buttons={shopPackageMenuItems}/>,
   
    children: shopPackageMenuItems
}